/**
 * calendar#34: other apps open one settings list straight from a link,
 *   /?settings=programs[&popup=1]   (Manage settings → Programs)
 *   /?settings=locations[&popup=1]  (Data & settings → Locations, calendar#33)
 *   /?settings=payors[&popup=1]     (Data & settings → Payors: RCM's list, calendar#37)
 *   /?settings=payments[&stripe=return|refresh]  (Data & settings → Payments: where Stripe's
 *     hosted onboarding comes back to, ehr#331)
 *   /?settings=users[&user=<id>][&popup=1]  (Users & Profile, straight onto that user's
 *     profile: the Calendar's Add provider, ehr#232)
 * The Calendar's "Add program" / "Add or edit in the EHR" open these in a pop-up
 * window (popup=1); closing the list then closes that window. The params are cleared
 * when the list closes.
 */

export const SETTINGS_LINKS = ['programs', 'locations', 'payors', 'payments', 'users'] as const;
export type SettingsLink = (typeof SETTINGS_LINKS)[number];

export interface SettingsParams {
  key: SettingsLink;
  popup: boolean;
  /** settings=users only: open this user's profile. */
  user?: string;
}

export function parseSettingsParams(search: string): SettingsParams | null {
  const p = new URLSearchParams(search);
  const key = p.get('settings');
  if (!key || !(SETTINGS_LINKS as readonly string[]).includes(key)) return null;
  const user = key === 'users' ? (p.get('user') ?? '').trim() : '';
  return { key: key as SettingsLink, popup: p.get('popup') === '1', ...(user ? { user } : {}) };
}

export function readSettingsParam(): SettingsParams | null {
  return parseSettingsParams(window.location.search);
}

export function clearSettingsParams(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('settings') && !url.searchParams.has('popup')) return;
  url.searchParams.delete('settings');
  url.searchParams.delete('popup');
  url.searchParams.delete('user');
  url.searchParams.delete('stripe');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}
